import useMediaQuery from '@material-ui/core/useMediaQuery';
import { DEVICE_BREAKPOINTS } from '../breakpoints';

/**
 * Hook responsive per i function component.
 *
 * Costruito su useMediaQuery di MUI v4 (gia' presente nel progetto) usando le
 * stesse soglie di breakpoints.js. NON contiene logica applicativa: serve solo
 * a scegliere stili/layout in base alla larghezza del viewport.
 *
 * @returns {{ isPhone: boolean, isTablet: boolean, isDesktop: boolean,
 *             isPhoneOrTablet: boolean, device: 'phone'|'tablet'|'desktop' }}
 *
 * Esempio:
 *   const { isPhone } = useBreakpoint();
 *   <div style={{ paddingLeft: isPhone ? 10 : 250 }} />
 */
export default function useBreakpoint() {
  // noSsr: valuta la media query in modo sincrono al primo render (lato client),
  // cosi' i componenti che leggono il valore al mount (es. defaultExpanded di una
  // fisarmonica) hanno subito il valore corretto invece di partire da `false`.
  const options = { noSsr: true };
  const isPhone = useMediaQuery(`(max-width:${DEVICE_BREAKPOINTS.phoneMaxWidth}px)`, options);
  const isTablet = useMediaQuery(
    `(min-width:${DEVICE_BREAKPOINTS.tabletMinWidth}px) and (max-width:${DEVICE_BREAKPOINTS.tabletMaxWidth}px)`,
    options
  );
  const isDesktop = useMediaQuery(`(min-width:${DEVICE_BREAKPOINTS.desktopMinWidth}px)`, options);

  let device = 'desktop';
  if (isPhone) device = 'phone';
  else if (isTablet) device = 'tablet';

  return {
    isPhone,
    isTablet,
    isDesktop,
    isPhoneOrTablet: isPhone || isTablet,
    device,
  };
}
